// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { List, Map } from 'immutable';
import startCase from 'lodash/startCase';
import { createSelector } from 'reselect';
import { NAME } from './constants.js';

const emptyMap = Map();
const emptyList = List();

const getIntegrationsState = (state) => state[NAME];

export const getProvider = (_, props) => props.provider;
export const getDataType = (_, props) => props.type;

export const getProviderConfig = createSelector(getIntegrationsState, getProvider, (state, provider) =>
  state.getIn(['providers', provider], emptyMap).toJS()
);

export const getIntegration = createSelector(getIntegrationsState, getProvider, (state, provider) =>
  state.getIn(['data', provider], emptyMap)
);

export const getIntegrationData = createSelector(getIntegration, getDataType, (state, type) => state.get(type));

export const getPublishTargetsOptions = createSelector(getIntegration, getProvider, (state, provider) => {
  const publishTargets = state.getIn(['publishTargets', 'data']) || emptyList;
  const publishTargetsOptions = publishTargets.map((site) =>
    site.set('value', site.get('id')).set('description', site.get('adminUrl'))
  );
  return publishTargetsOptions.push(
    Map({
      icon: 'add',
      name: `Create New ${startCase(provider)} Site`,
      value: 'new'
    })
  );
});
